export default [
  '#F99CA3',
  '#9B8CBC',
  '#9A8BC0',
  '#C896C0',
  '#8CD3F4',
  '#92B0DB',
  '#D5E39E',
  '#99CDA0',
  '#F9CD8F',
  '#F19E80',
  '#F4B588',
  '#EF9A9A',
  '#F48FB1',
  '#CE93D8',
  '#B39DDB',
  '#9FA8DA',
  '#90CAF9',
  '#81D4FA',
  '#80DEEA',
  '#80CBC4',
  '#A5D6A7',
  '#C5E1A5',
  '#FFAB91',
  '#BCAAA4',
  '#B0BEC5'
];
